import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { translations, type Language, type TranslationKey } from './translations';

interface LanguageState {
  lang: Language;
  setLang: (lang: Language) => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      lang: 'ms',
      setLang: (lang) => set({ lang }),
    }),
    { name: 'teleweb-lang' }
  )
);

export function useTranslation() {
  const { lang, setLang } = useLanguageStore();

  const t = (key: TranslationKey): string => {
    const entry = translations[key];
    if (!entry) return key;
    return entry[lang] || entry.ms;
  };

  return { t, lang, setLang };
}
